<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">车船实时定位</div>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <MapView MapKey="DefaultMap" MapLayers="观光车,游船" @layerButtonClick="layerButtonClick "></MapView>
        </div>
      </zj-layout-main>
    </zj-layout-container>
    <el-dialog class="map_popup_dialog" destroy-on-close="true" top="30vh" :visible.sync="isSendMsgDialogVisible" title="发送信息">
        <SendMsgPopup :Phone="phone"></SendMsgPopup>
    </el-dialog>
    <el-dialog class="map_popup_dialog" destroy-on-close="true" top="30vh" :visible.sync="isVideoCallDialogVisible" title="视频通话">
        <VideoCallPopup :Phone="phone"></VideoCallPopup>
    </el-dialog>
  </div>
</template>

<script>
import MapView from "./components/MapView";
import SendMsgPopup from './components/SendMsgPopup';
import VideoCallPopup from './components/VideoCallPopup';

export default {
  name: "VehicleSchedulingView",
  componentName: "VehicleSchedulingView",
  components: {
    MapView,
    SendMsgPopup,
    VideoCallPopup
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      isSendMsgDialogVisible:false,
      isVideoCallDialogVisible:false,
      phone:""
    };
  },
  methods: {
    layerButtonClick:function(data)
    {
      let e = data.e;
      switch(data.action)
      {
        case "sendmsg":
          this.phone = e.data.SimNo;
          this.isSendMsgDialogVisible = true;
          break;
        case "videocall":
          this.phone = e.data.SimNo;
          this.isVideoCallDialogVisible = true;
          break;
        default:
          this.$message({ type:"warning", message: data.action + "未实现"});
          break;
      }
    }
  },
  created() {},
  mounted() {
    this.logInfo.ActionName = "实时车辆监控查看";
    this.logInfo.LogMessage = "实时车辆监控查看";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "实时车辆监控";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "Home",
  action: "VehicleScheduling",
};
</script>

<style scoped>
.zj-vehicleview-root{
  height:100%;
  width: 100%;
}
</style>